export default "__VITE_ASSET__a31010b3__"